<template>
  <div class="home max">
    <div class="banner">
      <img
        class="banner_img"
        src="../../static/img/cpzs_banner.png"
        alt=""
      >
    </div>
    <div class="home_content w1200">
      <img
        src="../../static/img/cpzs_cpzs.png"
        alt=""
      >
      <ul class="content">
        <li
          v-for="(item,i) in content"
          :key="i"
          @click="$router.push({path:item.path })"
        >
          <img
            :src="item.img"
            alt=""
          >
          <div class="con_text">
            <h4>{{item.js}}</h4>
            <p>{{item.text}}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      content: [
        // {
        //   js: "热保APP",
        //   img: require("../../static/img/cpzs_rb.png"),
        //   text: "热保APP,专为保险代理人打造的移动互联...",
        //   path: "/cpfz?id=5"
        // },
        // {
        //   js: "联合保APP",
        //   img: require("../../static/img/cpzs_lhb.png"),
        //   text: "联合保APP,专为保险代理人打造的移动互联...",
        //   path: "/cpfz?id=1"
        // },
        {
          js: "小二保险APP",
          img: require("../../static/img/cpzs_xe.png"),
          text: "小二保险APP,专为保险代理人打造的移动互联...",
          path: "/cpfz?id=4"
        },
        // {
        //   js: "紫尊保APP",
        //   img: require("../../static/img/cpzs_zzb.png"),
        //   text: "紫尊保APP,专为保险代理人打造的移动互联...",
        //   path: "/cpfz?id=3"
        // },
        // {
        //   js: "利车保APP",
        //   img: require("../../static/img/cpzs_lcb.png"),
        //   text: "利车保APP,专为保险代理人打造的移动互联...",
        //   path: "/cpfz?id=2"
        // },
        // {
        //   js: "飞猪保险APP",
        //   img: require("../../static/img/cpzs_fz.png"),
        //   text: "飞猪保险APP,专为保险代理人打造的移动互联...",
        //   path: "/cpfz?id=0"
        // },
        // {
        //   js: "太慧宝APP",
        //   img: require("../../static/img/cpzs_thb.png"),
        //   text: "太慧宝APP,专为保险代理人打造的移动互联...",
        //   path: "/cpfz?id=6"
        // },
        // {
        //   js: "鼎龙宝APP",
        //   img: require("../../static/img/cpzs_dlb.png"),
        //   text: "鼎龙宝APP,专为保险代理人打造的移动互联...",
        //   path: "/cpfz?id=7"
        // }
        // ,
        // {
        //   js: "桂保宝APP",
        //   img: require("../../static/img/gbb.png"),
        //   text: "桂保宝APP,专为保险代理人打造的移动互联...",
        //   path: "/cpfz?id=8"
        // }
      ]
    };
  }
};
</script>

<style  lang="scss" scoped>
.home_content {
  padding: 60px 40px;
  overflow: hidden;
  background-color: #fff;
  .content {
    padding-top: 20px;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    li {
      margin-top: 40px;
      width: 265px;
      color: #3c3c3c;
      // margin-left: 80px;
      cursor: pointer;
      .con_text {
        border: 1px solid #cacaca;
        border-top: 0;
        h4 {
          text-align: center;
          padding-top: 20px;
          color: #303030;
          font-weight: 500;
          font-size: 24px;
        }
        p {
          font-size: 18px;
          text-align: center;
          padding: 30px 20px 50px 20px;
          color: #6b6b6b;
        }
      }
    }
    li:hover .con_text {
      border-color: #5282c2;
      transition: all 0.6s;
      h4 {
        color: #5381bc;
      }
    }
    li:nth-child(2),li:nth-child(5),li:nth-child(8) {
      margin: 0 160px;
      margin-top: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Product.vue